import { RecommendationService } from "@/services/RecommendationService";
import { useActiveUser } from "@/store/selectors";
import { useHasRecommendedPlaylists } from "@/store/selectors/playlistSelectors";
import {
  useAllowAdvizerRecs,
  useAllowPlaylistRecs,
  useIsRequestingRecommendedAdvizers,
  useIsRequestingRecommendedPlaylists,
  useUserHasRecommendedAdvizers,
} from "@/store/selectors/userProfileSelectors";
import { useEffect, useState } from "react";

export function RecommendationLogic() {
  const activeUser = useActiveUser();

  const { allowAdvizerRecs } = useAllowAdvizerRecs();
  const hasRecommendedAdvizers = useUserHasRecommendedAdvizers();
  const isRequestingRecommendedAdvizers = useIsRequestingRecommendedAdvizers();
  const [didRequestRecommendedAdvizers, setDidRequestRecommendedAdvizers] =
    useState(false);

  const { allowPlaylistRecs } = useAllowPlaylistRecs();
  const hasRecommendedPlaylists = useHasRecommendedPlaylists();
  const isRequestingRecommendedPlaylists =
    useIsRequestingRecommendedPlaylists();
  const [didRequestRecommendedPlaylists, setDidRequestRecommendedPlaylists] =
    useState(false);

  useEffect(() => {
    if (
      allowAdvizerRecs &&
      !hasRecommendedAdvizers &&
      !isRequestingRecommendedAdvizers &&
      !didRequestRecommendedAdvizers
    ) {
      RecommendationService.getRecommendedAdvizers({
        userId: activeUser?.id || "",
      });

      setDidRequestRecommendedAdvizers(true);
    }
  }, [
    activeUser?.id,
    allowAdvizerRecs,
    didRequestRecommendedAdvizers,
    hasRecommendedAdvizers,
    isRequestingRecommendedAdvizers,
  ]);

  useEffect(() => {
    if (
      allowPlaylistRecs &&
      !hasRecommendedPlaylists &&
      !isRequestingRecommendedPlaylists &&
      !didRequestRecommendedPlaylists
    ) {
      RecommendationService.getRecommendedPlaylists({
        userId: activeUser?.id || "",
        includeAllUserProfileData: true,
      });
      setDidRequestRecommendedPlaylists(true);
    }
  }, [
    activeUser?.id,
    allowPlaylistRecs,
    didRequestRecommendedPlaylists,
    hasRecommendedPlaylists,
    isRequestingRecommendedPlaylists,
  ]);

  return null;
}
